var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconOnlyMe(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.007 23.68c.988 0 1.89-.262 2.706-.787a5.783 5.783 0 0 0 1.958-2.123c.489-.89.734-1.888.734-2.993 0-1.067-.245-2.037-.734-2.91a5.767 5.767 0 0 0-1.965-2.087c-.82-.52-1.72-.78-2.699-.78-.988 0-1.893.262-2.713.787a5.825 5.825 0 0 0-1.965 2.095c-.489.872-.73 1.842-.72 2.91 0 1.094.243 2.087.727 2.978a5.727 5.727 0 0 0 1.951 2.123 4.926 4.926 0 0 0 2.72.787ZM32.146 36c1.165 0 1.974-.179 2.426-.536.452-.357.678-.856.678-1.496 0-.854-.263-1.743-.79-2.666-.527-.924-1.282-1.79-2.266-2.597-.983-.807-2.167-1.464-3.551-1.97-1.385-.505-2.93-.758-4.636-.758-1.715 0-3.265.253-4.65.758-1.384.506-2.568 1.163-3.551 1.97-.984.808-1.74 1.673-2.266 2.597-.527.923-.79 1.812-.79 2.666 0 .64.226 1.139.678 1.496.452.357 1.256.536 2.412.536h16.306Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOnlyMe);
export default __webpack_public_path__ + "static/media/icon-only-me.aded6107bb91267b651674a9282c3109.svg";
export { ForwardRef as ReactComponent };